import React, {Component} from 'react';
import {IntercomAPI} from 'react-intercom';
import FeedData from './feed/FeedData'
import NoFeeds from './feed/NoFeeds'
import $ from 'jquery';
import authService from "../../services/authService";

// import ReactGA from "react-ga";

class Feeds extends Component {

    handleFeedMenu = () => {
        $('.feed-dropdown').fadeToggle();
    };

    componentDidMount() {
        //ReactGA.pageview(window.location.pathname + window.location.search);

    }

    render() {
        const {
            sources, activateFeed,
            //feeds_shared,
            onClick, openModal, toggleFeedInfo, editing, rss_valid, updateUser,
            user_facebook_pages, facebook_pages_shared, addSource, deleteFeed, enablePlatform, platforms_enabled,
            updateSources, selectSource, teams, selectedSource
        } = this.props;
        //console.log('selected source: ', selectedSource);
        $('.bkg-img').css('position', 'absolute');
        //let source, onlypage = "";
        let source = "";
        if (sources) {
            source = sources.filter(source =>
                source.id.toString() === this.props.selectedSource.toString())[0];
        }
        // if (!source &&
        //     feeds_shared && selectedSource) {
        //     source = feeds_shared.filter(source =>
        //         source.project_id.toString() === selectedSource.toString())[0];
        //     // console.log('feeds_shared: ', feeds_shared, source, this.props.selectedSource )
        // }
        return <React.Fragment>
            <h1 className='main-title'>Workspace Settings</h1>


            {sources.length
                //|| feeds_shared.length
                ?
                <FeedData
                    source={source}
                    user={this.props.user}
                    onClick={onClick}
                    activateFeed={activateFeed}
                    deleteFeed={deleteFeed}
                    toggleFeedInfo={toggleFeedInfo}
                    editing={editing}
                    user_facebook_pages={user_facebook_pages}
                    facebook_pages_shared={facebook_pages_shared}
                    enablePlatform={enablePlatform}
                    platforms_enabled={platforms_enabled}
                    rss_valid={rss_valid}
                    openModal={openModal}
                    updateUser={updateUser}
                    updateSources={updateSources}
                    selectSource={selectSource}
                    teams={teams}
                    selectedSource={this.props.selectedSource}
                    selectedSourceNode={this.props.selectedSourceNode}
                    appPropagateUserData={this.props.appPropagateUserData}
                    appPropagateTeams={this.props.appPropagateTeams}
                    updateUserFromServer={this.props.updateUserFromServer}
                    {...this.props}
                />
                :
                <NoFeeds userFullName={authService.getCurrentUserName()}/>
            }
        </React.Fragment>
    }
}


export default Feeds;